module.exports = __webpack_public_path__ + "img/mode-3.fb44b54f.png";